import { jsPDF } from "jspdf";

const M = 14;
const PAGE_W = 210;
const PAGE_H = 297;
const TABLE_W = PAGE_W - M * 2;
const COLS = [
    { key: "fabric", label: "Fabric", w: 70 },
    { key: "shade", label: "Shade", w: 28 },
    { key: "coat", label: "Coat", w: 18 },
    { key: "pant", label: "Pant", w: 18 },
    { key: "vest", label: "Vest", w: 18 },
    { key: "meters", label: "Meters", w: 30 },
];

const cell = (doc, text, x, y, w, align) => {
    const pad = 1.6;
    const s = String(text ?? "");
    if (align === "right") doc.text(s, x + w - pad, y, { align: "right" });
    else doc.text(s, x + pad, y);
};

function drawHead(doc, pack, meta, pageNo) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(12);
    doc.text(pack.name, M, 16);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(60);
    doc.text("Fabric order", M, 22);
    doc.text(meta.when, PAGE_W - M, 16, { align: "right" });
    doc.setFontSize(8);
    doc.text(meta.scope || "All stalls", PAGE_W - M, 22, { align: "right" });
    doc.setTextColor(90);
    doc.text(`Page ${pageNo}`, PAGE_W - M, 28, { align: "right" });
    return 32;
}

function drawTableHead(doc, y) {
    doc.setFillColor(20, 22, 26);
    doc.rect(M, y, TABLE_W, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(255);
    let x = M;
    COLS.forEach((c) => {
        const align = c.key === "fabric" || c.key === "shade" ? "left" : "right";
        cell(doc, c.label, x, y + 5.4, c.w, align);
        x += c.w;
    });
    return y + 8;
}

/** One PDF per dealer that has meters to order. Returns how many files were saved. */
export function downloadFabricOrderPDFs(order, meta) {
    const when = meta?.when || "";
    let saved = 0;
    order.packs.filter((p) => p.rows.length > 0).forEach((pack, i) => {
        const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait", compress: true });
        let page = 1;
        let y = drawHead(doc, pack, { when, scope: meta?.scope }, page);
        y = drawTableHead(doc, y);
        const bottom = PAGE_H - 16;

        pack.rows.forEach((r, idx) => {
            if (y + 8 > bottom) {
                doc.addPage();
                page += 1;
                y = drawHead(doc, pack, { when, scope: meta?.scope }, page);
                y = drawTableHead(doc, y);
            }
            if (idx % 2 === 1) {
                doc.setFillColor(246, 247, 249);
                doc.rect(M, y, TABLE_W, 8, "F");
            }
            doc.setDrawColor(220);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.setTextColor(20);
            let x = M;
            const vals = {
                fabric: r.fabric,
                shade: r.shade || "—",
                coat: r.coat || "—",
                pant: r.pant || "—",
                vest: r.vest || "—",
                meters: r.meters.toFixed(1),
            };
            COLS.forEach((c) => {
                doc.rect(x, y, c.w, 8);
                const align = c.key === "fabric" || c.key === "shade" ? "left" : "right";
                cell(doc, vals[c.key], x, y + 5.4, c.w, align);
                x += c.w;
            });
            y += 8;
        });

        if (y + 10 > bottom) {
            doc.addPage();
            page += 1;
            y = drawHead(doc, pack, { when, scope: meta?.scope }, page);
        }
        doc.setFillColor(20, 22, 26);
        doc.rect(M, y, TABLE_W, 8, "F");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.setTextColor(255);
        cell(doc, "Total", M, y + 5.4, COLS[0].w, "left");
        const pcs = pack.rows.reduce((a, r) => a + r.coat + r.pant + r.vest, 0);
        cell(doc, `${pcs} pcs`, M + COLS[0].w, y + 5.4, COLS[1].w, "left");
        const meterX = M + COLS.slice(0, 5).reduce((a, c) => a + c.w, 0);
        cell(doc, `${pack.meters.toFixed(1)} m`, meterX, y + 5.4, COLS[5].w, "right");

        const stamp = when.replace(/[^\dA-Za-z]+/g, "-").replace(/^-|-$/g, "");
        const file = `${pack.name.replace(/\s+/g, "-")}-${stamp || "order"}.pdf`;
        if (i === 0) doc.save(file);
        else setTimeout(() => doc.save(file), 400 * i);
        saved += 1;
    });
    return saved;
}
